export default __webpack_public_path__ + "static/media/Spinner-1s-150px.44155c0b.svg";